import { Directive, inject } from '@angular/core';
import { BaseComponent } from './base.component';
import { BehaviorSubject, debounceTime, fromEvent, map } from 'rxjs';
import { HelperService } from 'utils/helper';

@Directive()
export class BasePlusComponent extends BaseComponent {
  templateUtils$: BehaviorSubject<{
    isMobileNotIpad: boolean;
    isMobileIpad: boolean;
    isMobile: boolean;
    isMobileOrIpad: boolean;
  }>;
  isMobileNotIpad: () => boolean;
  isMobileIpad: () => boolean;
  isMobile: () => boolean;
  isMobileOrIpad: () => boolean;
  isSafari: boolean;
  isMobileSafari: boolean;
  isCustomSmallScreen: (width: number) => boolean;
  private helperService: HelperService;

  constructor() {
    super();
    this.helperService = inject(HelperService);
    this.isMobileNotIpad = this.helperService.isMobileNotIpad;
    this.isMobileIpad = this.helperService.isMobileIpad;
    this.isMobile = this.helperService.isMobile;
    this.isMobileOrIpad = this.helperService.isMobileOrIpad;
    this.isSafari = this.helperService.isSafari();
    this.isMobileSafari = this.helperService.isMobileSafari();
    this.isCustomSmallScreen = this.helperService.isCustomSmallScreen;
    this.isPlatformBrowser = this.helperService.isPlatformBrowser;
    this.isPlatformServer = this.helperService.isPlatformServer;
    this.templateUtils$ = new BehaviorSubject({
      isMobileNotIpad: this.isMobileNotIpad(),
      isMobileIpad: this.isMobileIpad(),
      isMobile: this.isMobile(),
      isMobileOrIpad: this.isMobileOrIpad(),
    });
    this.subscriptions.push(
      fromEvent(this.helperService.win, 'resize', { passive: true })
        .pipe(
          debounceTime(50),
          map(() => ({
            isMobileNotIpad: this.isMobileNotIpad(),
            isMobileIpad: this.isMobileIpad(),
            isMobile: this.isMobile(),
            isMobileOrIpad: this.isMobileOrIpad(),
          })),
        )
        .subscribe(next => {
          this.templateUtils$?.next(next);
        }),
    );
  }
}
